import { format, parseISO } from "date-fns";

/**
 * Format a date string or Date object as German date (dd.MM.yyyy).
 * Returns empty string for falsy input.
 */
export function formatDate(value) {
  if (!value) return "";
  const date = typeof value === "string" ? parseISO(value) : value;
  return format(date, "dd.MM.yyyy");
}

const BERLIN_DATETIME = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Berlin",
});

/**
 * Format a datetime string or Date object as German datetime (dd.MM.yyyy, HH:mm)
 * in Europe/Berlin timezone. Naive ISO strings (no offset) are treated as UTC.
 */
export function formatDateTime(value) {
  if (!value) return "";
  let date;
  if (typeof value === "string") {
    const hasTimezone = /Z|[+-]\d{2}:?\d{2}$/.test(value);
    date = parseISO(hasTimezone ? value : value + "Z");
  } else {
    date = value;
  }
  return BERLIN_DATETIME.format(date);
}
